import * as actions from "actions/location";
import * as R from "ramda";

export default (state = {}, { type, payload }) => {
  switch (type) {
    case actions.FETCH_ALL_SUCCESS: {
      const locations = {};
      payload.data.forEach(location => {
        locations[location.id] = location;
      });
      return locations;
    }

    case actions.DELETE_ONE_SUCCESS: {
      return R.dissoc(payload.id, state);
    }

    case actions.UPDATE_ONE_SUCCESS: {
      return R.assoc(payload.data.id, payload.data, state);
    }

    case actions.CREATE_ONE_SUCCESS: {
      return R.assoc(payload.data.id, payload.data, state);
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/location/byId.js